import it from './it.json';
import en from './en.json';

const resources = {
  it,
  en,
};

export default resources;
